import React, { Component } from 'react';

export default class EnrollPromo extends Component {
  render() {
    return ( <div className="nmpromo" /> );
  }
}


// WEBPACK FOOTER //
// ./src/components/EnrollPromo.jsx